import React from "react";
import styled from "styled-components";
import PrintableProgressBar from "./PrintableProgressBar";

const MoodListContainer = styled.div`
    width: min-content;
    padding: 10px;
  `;

const ProgressContainer = styled.div`
    width: 175px;
    display: flex;
    justify-content: space-between;
`;

const MoodItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 10px;
    font: normal normal bold 25px / 33px Manrope;
`;

const MoodLabel = styled.div`
    width: 100px;
    letter-spacing: 0px;
    font-family: Manrope;
    font-size: 1.2rem;
    line-height: normal; 
    font-weight: medium;
`;

const MoodPercentageLabel = styled.div`/* width: 100px; */
    letter-spacing: 0px;
    font-family: Manrope;
    font-size: 1.2rem;
    line-height: normal;
    text-align: left;
    color: #000000;
    font-weight: medium;
`;

const PrintableMoodDistributionList = ({ moodData }) => {
    const totalCheckins = moodData.reduce((acc, item) => acc + item.count, 0);
    const maxCount = Math.max(...moodData.map(mood => mood.count));
    const moodEmoji = {
        Happy: "😁",
        Content: "😊",
        Neutral: "😐",
        Sad: "😔",
        Unhappy: "😢",
        Tired: "😴",
        Stressed: "😬",
        Sick: "🤒",
    };
    return (
        <MoodListContainer>
            {moodData && moodData.map(mood => {
                const progressBarMoodCount = mood.count === 0 ? 0 : (mood.count / maxCount);
                const numberMoodCount = mood.count === 0 ? 0 : (mood.count / totalCheckins);
                return (
                    <MoodItem key={mood.moodType}>
                        <div style={{ margin: "0px 15px", fontSize: "3rem" }}>
                            {moodEmoji[mood.moodType]}
                        </div>
                        <div style={{ flexDirection: "row", marginLeft: "1.5rem" }}>
                            <MoodLabel>{mood.moodType}</MoodLabel>
                            <ProgressContainer>
                                <PrintableProgressBar value={ progressBarMoodCount * 100} moodType={mood.moodType} />
                                <MoodPercentageLabel>
                                    {Number(numberMoodCount * 100).toFixed(0)}%
                                </MoodPercentageLabel>
                            </ProgressContainer>
                        </div>
                    </MoodItem>
                );
            })}
        </MoodListContainer>
    );
};

export default PrintableMoodDistributionList;